import React, { useState, ChangeEvent, useContext } from 'react';

import OwnerContext from '../context/OwnerContext';
import { OwnerHttpServiceAuth } from '../services/ApiServices';
import { ErrorDanish } from '../helpers/ErrorDanish';
import { ConsentRevokeReasonTypeDanish } from '../helpers/EnumsDanish';
import { ConsentRevokeReasonType } from '../helpers/EnumsInternal';
import MainErrorText from './MainErrorText';


type HeaderProps = {
    setIsPopoverOpen: Function,
    revokeCollectionId: number,
    revokedCount: number
}


function OwnerRevokeReasonModal(props: HeaderProps) {
    let { setIsPopoverOpen, revokeCollectionId, revokedCount } = props;
    
    const ownerLoginObject = useContext(OwnerContext);
    const [isSendButtonDisabled, setIsSendButtonDisabled] = useState<boolean>(true);
    const [spinner, showSpinner] = useState<boolean>(false);
    const [errorText, setErrorText] = useState<string>('');
    const [revokeReason, setRevokeReason] = useState<ConsentRevokeReasonType>(ConsentRevokeReasonType.None);
    const [otherReason, setOtherReason] = useState<string>('');


    function onOtherReasonFieldChange(inputOtherReason: string) {
        setOtherReason(inputOtherReason);
        setIsSendButtonDisabled(inputOtherReason?.trim() === '');
    }

    function onSelectReasonClick(revokeReasonType: ConsentRevokeReasonType) {
        setRevokeReason(revokeReasonType);
        if (Number(revokeReasonType) === ConsentRevokeReasonType.Other)
            setIsSendButtonDisabled(otherReason?.trim() === '');
        else                
            setIsSendButtonDisabled(false);
    }


    async function handleReasonSubmitClick() {
        showSpinner(true);
        setIsSendButtonDisabled(true);

        await OwnerHttpServiceAuth(ownerLoginObject, 'owners/reason' , 'POST',
            { CollectionId: revokeCollectionId, ReasonType: revokeReason, OtherReason: otherReason?.trim() })
        .then(result => {
            if (result === null || result === undefined) {
                setErrorText(ErrorDanish["GeneralError"]);

            } else {
                switch(result.status) {
                    case 204: // No Content
                        setIsPopoverOpen(false);
                        return;
                    case 401:   // Unauthorized
                        setErrorText(ErrorDanish['Unauthorized']);
                    break;
                    case 403:
                        setErrorText(ErrorDanish['Forbidden']);
                        break;
                    case 409:
                        setErrorText(ErrorDanish['ConcurrencyException']);
                        break;
                    default:    // General error
                        setErrorText(ErrorDanish['DbWriteValuesError']);
                    break;
                }
            }
            setIsSendButtonDisabled(false);
            showSpinner(false);
        })
        .catch(e => {
            console.log("Something fishy happened: " + e);
            setErrorText(ErrorDanish["DbConxError"]);
            setIsSendButtonDisabled(false);
            showSpinner(false);
        });
    }


    return (
        <div className="modal show" id="modal-name">
            <div className="modal-container">
                <div className="modal-content">

                    <h2>Tilbagekaldelse</h2>

                    <p>{ revokedCount } samtykke{ revokedCount > 1 && 'r' } blev tilbagekaldt.</p>
                    <div className="seperator-sm"></div><br />

                    <h3>Har du lyst til at fort&aelig;lle os hvorfor?</h3>

                    { Object.keys(ConsentRevokeReasonType).filter(key => !isNaN(parseInt(key)) && key > '1').map((key: any) => (
                        <div key={key} className="radio-container">
                            <input type="radio" name="revokeReason" value={key} defaultChecked={ key === revokeReason ? true : undefined }
                                onClick={ () => { onSelectReasonClick(key); } } />
                            <label>{ ConsentRevokeReasonTypeDanish[key] }</label>
                        </div>
                    ))}
                    <div className="radio-container">
                        <input type="radio" name="revokeReason" value={ConsentRevokeReasonType.Other}
                            onClick={ () => { onSelectReasonClick(ConsentRevokeReasonType.Other); } } />
                        <label>{ ConsentRevokeReasonTypeDanish[ConsentRevokeReasonType.Other] }</label>
                    </div>

                    { Number(revokeReason) === ConsentRevokeReasonType.Other &&
                        <div className="input-container">
                            <input type="text" name="otherReason" maxLength={60}
                                value={otherReason} onChange={(e: ChangeEvent<HTMLInputElement>) => onOtherReasonFieldChange(e.target.value)} />
                            <label htmlFor="otherReason">Anden &aring;rsag</label>
                        </div>
                    }

                    <div className="d-flex align-items-center btn-container">
                        <button className="btn" disabled={ isSendButtonDisabled } onClick={ handleReasonSubmitClick }>Send</button>
                        <button className="btn btn-delete" onClick={() => setIsPopoverOpen(false)}>Nej tak</button>
                        { spinner && <div className="loader loader-xs"><div></div><div></div><div></div><div></div></div> }
                    </div>

                    { errorText !== '' && <MainErrorText errorText={errorText} /> }
                </div>
            </div>
        </div>
    );
}

export default OwnerRevokeReasonModal;
